import { API_URL } from "../config";
import { fetchWithTransientRetry } from "./fetchWithTransientRetry";

const ANNOUNCEMENTS_CACHE_MS = 5000;
let announcementsBundleCache = null;
let announcementsBundleInflight = null;
let unreadCountCache = null;
let unreadCountInflight = null;

export async function getAnnouncementsBundle() {
  const now = Date.now();
  if (announcementsBundleCache && announcementsBundleCache.expiresAt > now) {
    return announcementsBundleCache.value;
  }
  if (announcementsBundleInflight) {
    return announcementsBundleInflight;
  }

  announcementsBundleInflight = Promise.all([
    fetchWithTransientRetry(`${API_URL}/announcements`, { credentials: "include" }),
    fetchWithTransientRetry(`${API_URL}/announcements/count-unread`, { credentials: "include" }),
  ])
    .then(async ([listRes, countRes]) => {
      if (!listRes.ok) {
        throw new Error("Announcements fetch failed");
      }

      const listPayload = await listRes.json();
      const countPayload = countRes.ok ? await countRes.json() : { count: 0 };
      const value = {
        announcements: Array.isArray(listPayload) ? listPayload : [],
        unreadCount: Math.max(0, Number(countPayload?.count) || 0),
      };

      announcementsBundleCache = {
        value,
        expiresAt: Date.now() + ANNOUNCEMENTS_CACHE_MS,
      };
      unreadCountCache = {
        value: value.unreadCount,
        expiresAt: Date.now() + ANNOUNCEMENTS_CACHE_MS,
      };
      return value;
    })
    .finally(() => {
      announcementsBundleInflight = null;
    });

  return announcementsBundleInflight;
}

export async function getAnnouncementsUnreadCount() {
  const now = Date.now();
  if (unreadCountCache && unreadCountCache.expiresAt > now) {
    return unreadCountCache.value;
  }
  if (announcementsBundleInflight) {
    return (await announcementsBundleInflight).unreadCount;
  }
  if (unreadCountInflight) {
    return unreadCountInflight;
  }

  unreadCountInflight = fetchWithTransientRetry(`${API_URL}/announcements/count-unread`, {
    credentials: "include",
  })
    .then(async (res) => {
      if (!res.ok) {
        return 0;
      }
      const payload = await res.json();
      const value = Math.max(0, Number(payload?.count) || 0);
      unreadCountCache = {
        value,
        expiresAt: Date.now() + ANNOUNCEMENTS_CACHE_MS,
      };
      return value;
    })
    .finally(() => {
      unreadCountInflight = null;
    });

  return unreadCountInflight;
}

export function clearAnnouncementsCache() {
  announcementsBundleCache = null;
  announcementsBundleInflight = null;
  unreadCountCache = null;
  unreadCountInflight = null;
}
